export let EmailOnBehalfTypes = /*#__PURE__*/function (EmailOnBehalfTypes) {
  EmailOnBehalfTypes["Sendgrid"] = "sendgrid";
  EmailOnBehalfTypes["Gmail"] = "gmail";
  return EmailOnBehalfTypes;
}({});
export class EmailOnBehalfSettingsModel {
  static fromDTO(dto) {
    if (dto.provider === EmailOnBehalfTypes.Sendgrid) {
      return new EmailOnBehalfSettingsModel({
        provider: EmailOnBehalfTypes.Sendgrid,
        email: 'system@notifications.sayanchor.com'
      });
    } else {
      return new EmailOnBehalfSettingsModel({
        provider: EmailOnBehalfTypes.Gmail,
        email: dto.email
      });
    }
  }
  static makeDisconnected() {
    return EmailOnBehalfSettingsModel.fromDTO({
      provider: EmailOnBehalfTypes.Sendgrid,
      email: null
    });
  }
  constructor(data) {
    this.data = data;
  }
  email() {
    return this.data.email;
  }
  isDisconnected() {
    return this.data.provider === EmailOnBehalfTypes.Sendgrid;
  }
}